import Icon from '@mui/icons-material/Business';
import { ListCompanies } from './ListCompanies';

export const PrmCompanyResourceConfig = {
  list: ListCompanies,
  icon: Icon,
  name: 'prm-companies',
};
